import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

/*
!!!CheckoutCreateInput

allowPartialAddresses (Boolean)
Allows setting partial addresses on a Checkout, skipping the full validation of attributes. The required attributes are city, province, and country. Full validation of addresses is still done at complete time.

customAttributes ([AttributeInput!])
A list of extra information that is added to the checkout.

email (String)
The email with which the customer wants to checkout.

lineItems ([CheckoutLineItemInput!])
A list of line item objects, each one containing information about an item in the checkout.

note (String)
The text of an optional note that a shop owner can attach to the checkout.

presentmentCurrencyCode (CurrencyCode)
The three-letter currency code of one of the shop's enabled presentment currencies. Including this field creates a checkout in the specified currency. By default, new checkouts are created in the shop's primary currency.

shippingAddress (MailingAddressInput)
The shipping address to where the line items will be shipped.
*/


const createCheckout = (
	`mutation ($input: CheckoutCreateInput!) {
		checkoutCreate(input: $input) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default createCheckout;
